import {getState} from '../../../store.js'
import {
  updateLabelConfig,
  LABEL_PROPERTY_ATTACH_CUSTOMS_INFO,
  attachCustomsInfoSelector,
  ADDITIONAL_DEPENDENT_PROPERTIES,
} from '../../../data/labelInfos/index.js'
import {FEDEX} from '../../../common/constants/ShipperNames.js'
import ConfigTextInput from './ConfigTextInput.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'

const LABEL_PROPERTY = 'export_compliance_statement'
const VALID_SHIPPER_TYPES = [FEDEX]

const EXPORT_COMPLIANCE_STATEMENT_DEPENDENT_PROPERTIES = [
  ...ADDITIONAL_DEPENDENT_PROPERTIES,
  LABEL_PROPERTY_ATTACH_CUSTOMS_INFO,
]

function dependentPropertiesFunc() {
  return EXPORT_COMPLIANCE_STATEMENT_DEPENDENT_PROPERTIES
}

export function exportComplianceStatementLabelPropertiesFunc(
  shipperType,
  labelInfoID,
) {
  const attachCustomsInfo = attachCustomsInfoSelector(getState(), {labelInfoID})

  return attachCustomsInfo ? [LABEL_PROPERTY] : []
}

export default function ExportComplianceStatement() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const [propertySpecs] = ExportComplianceStatement.propertySpecList
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigTextInput
      label="Export Compliance Statement"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {[labelProperty]: value})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
    />
  )
}

ExportComplianceStatement.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc: exportComplianceStatementLabelPropertiesFunc,
    dependentPropertiesFunc,
    validLabelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
  },
]
